import { CommunityPage } from '../pages/Community';

export const CommunityContainer = () => (
  <CommunityPage />
);
